import React from 'react'

import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { CardValue, SingleCard, SubText, TopHeader } from './style'

const InfoCardPast = ({
  background = COLORS.BLUE_T_95,
  padding = '15px 15px',
  width = 'auto',
  value,
  height,
  state,
  current,
  active,
  setEvaluations,
  count = 0,
  setPage,
}) => {
  const clickedFn = value => {
    setEvaluations(value)
    setPage(0)
  }
  return (
    <SingleCard
      onClick={() => clickedFn(value)}
      background={current && state == current ? COLORS.BLUE_T_80 : background}
      padding={padding}
      width={width}
      column
      flexStart
      height={height}
      styleProps={active}
    >
      <CardValue>{value?.toLowerCase()} Evaluations</CardValue>
      <TopHeader row spaceBetween alignCenter>
        <Flex row flexStart>
          <CardValue>{count}</CardValue>
          <SubText>Candidates</SubText>
        </Flex>
      </TopHeader>
    </SingleCard>
  )
}

export default InfoCardPast
